import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';

import { getHeroImageIndex } from './localStorage';
import { getSeasonalHeaderContent } from './seasonal';

import {
    HEADER_BACKGROUNDS,
    HEADER_BACKGROUND_BREAKPOINTS,
} from '../constants/background';

const getBoundedIndex = (imageIndex) => imageIndex % HEADER_BACKGROUNDS.length;

/**
 * @returns [Object: {
 *  images: [Array],
 *  attribution: [String]},
 *  Optional >
 *   shouldShowCustomHeader: [Boolean],
 *   customContentTitle: [String],
 *   customContentCtaLabel: [String],
 *   customContentCtaLink: [String],
 *   customContentCtaPrefix: [String],
 * ]
 */
export const getHeaderContent = ({ seasonalContent, fixedImageIndex } = {}) => {
    let response = getSeasonalHeaderContent(seasonalContent);

    if (isEmpty(response)) {
        const imageIndex = fixedImageIndex || getHeroImageIndex();

        if (imageIndex >= 0) {
            const boundedImageIndex = getBoundedIndex(imageIndex);

            response = HEADER_BACKGROUNDS[boundedImageIndex];
        }
    }

    return response;
};

export const getImageForBreakpoint = ({ windowWidth, imagesSet }) => {
    let imageUrl = imagesSet.mobile;

    if (windowWidth) {
        forEach(HEADER_BACKGROUND_BREAKPOINTS, (breakpointSize, keyName) => {
            if (windowWidth >= breakpointSize) {
                imageUrl = imagesSet[keyName];
            }
        });
    }

    return imageUrl;
};
